import { useEffect, useState, useLayoutEffect } from "react";

// router
import { useSearchParams } from "react-router-dom";

// services
import { getAppToken } from "../services/auth";

// components
import Error from "./Error";
import ConsentForm from "./ConsentForm";
import { getMember } from "../services/consent";

export default function UnderAgeConcent({ isMobile, setCurrentBrand }) {
  const [searchParams] = useSearchParams();
  const [brandId, setBrandId] = useState("");
  const [agreementId, setAgreementId] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [existingToken, setExistingToken] = useState(false);
  const [member, setMember] = useState({});
  const [error, setError] = useState(false);

  useLayoutEffect(() => {
    setAgreementId(searchParams.get("a"));
    setBrandId(searchParams.get("b"));
    setCurrentBrand(searchParams.get("b"));
    localStorage.setItem("current_brand", searchParams.get("b"));
  }, []);

  useEffect(() => {
    if (agreementId && brandId && !existingToken) {
      const interval = setInterval(() => {
        getAuthToken(interval);
      }, 1000);
    }
  }, [agreementId, brandId]);

  const getAuthToken = async (interval) => {
    setIsLoading(true);
    try {
      const response = await getAppToken();
      if (response.data) {
        localStorage.setItem("access_token_bt", response.data.access_token);
        localStorage.setItem("refresh_token_bt", response.data.access_token);
        clearInterval(interval);
        setExistingToken(true);
        getMemberUnderAge();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getMemberUnderAge = () => {
    getMember(agreementId)
      .then((response) => {
        if (response.data.status === "success") {
          setMember(response.data.data[0]);
        } else {
          setMember(response.data.message[0]);
          console.log("error");
          setError(true);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      {!isLoading ? (
        <>
          {error ? (
            <Error
              linkButton={""}
              customMessage={member.message}
              customTitle={"ERROR"}
            />
          ) : (
            <ConsentForm
              agreementId={agreementId}
              brandId={brandId}
              isMobile={isMobile}
              member={member}
            />
          )}
        </>
      ) : (
        <Error hasLoader />
      )}
    </>
  );
}
